import { useEffect, useState } from 'react';

export default function useElapsedTimer(timestamp) {
  const [elapsed, setElapsed] = useState('00:00');

  useEffect(() => {
    if (!timestamp) return;

    const calcElapsed = () => {
      const start = new Date(timestamp).getTime();
      const now = Date.now();
      const diffSec = Math.floor((now - start) / 1000);
      const mins = Math.floor(diffSec / 60);
      const secs = diffSec % 60;
      return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
    };

    setElapsed(calcElapsed());
    const interval = setInterval(() => setElapsed(calcElapsed()), 1000);
    return () => clearInterval(interval);
  }, [timestamp]);

  return elapsed;
}
